import { render, staticRenderFns } from "./~RevenueOverview.vue?vue&type=template&id=555150c4"
import script from "./~RevenueOverview.vue?vue&type=script&lang=js"
export * from "./~RevenueOverview.vue?vue&type=script&lang=js"
import style0 from "./~RevenueOverview.vue?vue&type=style&index=0&id=555150c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports